import Cookies from "js-cookie";

export const BASE_URL =
  process.env.REACT_APP_IS_LIVE === "true"
    ? process.env.REACT_APP_LIVE_API_URL
    : process.env.REACT_APP_LOCAL_API_URL;

const schoolCode = Cookies.get("schoolCode") ?? "";

export const IMAGE_BASE_URL = 
  process.env.REACT_APP_IS_LIVE === "true"
    ? 'https://' + schoolCode + '.swiftcampus.com'
    : 'http://localhost/' + schoolCode